import React from 'react';
import { CreateUserForm } from 'shared/ui';
import { AppLinks } from 'app/router/consts/app-links.enum';
import { validateCreateAdministratorForm } from '../model/validate-create-administrator-form';
import { BusinessApi } from 'shared/api';

interface IProps {
  businessId: string;
}

export const CreateAdministratorForm: React.FC<IProps> = ({ businessId }) => {
  return (
    <CreateUserForm
      title="Регистрация управляющего"
      fioLabel="ФИО управляющего"
      buttonText="Регистрация управляющего"
      businessId={businessId}
      navigateLink={AppLinks.BusinessLink.replace(':id', businessId)}
      pointFilter={{ adminFree: true }}
      successMessage="Управляющий успешно создан"
      onSubmit={async (data) => {
        await BusinessApi.createAdministrator({
          email: data.email,
          fio: data.fio,
          phone: data.phone,
          password: data.password,
          businessId,
          pointIds: data.pointIds,
        });
      }}
      validate={(data) =>
        validateCreateAdministratorForm({
          fio: data.fio.trim(),
          email: data.email,
          phone: data.phone,
          password: data.password,
          confirmPassword: data.confirmPassword,
        })
      }
    />
  );
};
